<template>
  <div>
    <div class="action-lists">
      <div class="left-btns">
        <div class="" @click="showOther('plan')">推广计划</div>
        <div class="" @click="showOther('group')">推广组</div>
        <div class="selected">创意</div>
      </div>
      <!-- <div class="right-action">
        <div class="" title="添加创意" @click="add()"><img src="../../../assets/images/add-icon.png" alt="添加创意"></div>
        <div class="" title="启用创意" @click="changeStatus(1)"><img src="../../../assets/images/start-icon.png" alt="启用创意"></div>
        <div class="" title="暂停创意" @click="changeStatus(0)"><img src="../../../assets/images/stop-icon.png" alt="暂停创意"></div>
        <div class="" title="删除创意" @click="del()"><img src="../../../assets/images/del-icon.png" alt="删除创意"></div>
        <el-input placeholder="搜索相关内容" v-model="keyword" class="input-with-select" style="width: 200px; margin-right: 20px;">
            <el-button slot="append" icon="el-icon-search" @click="search()"></el-button>
          </el-input>
      </div> -->
    </div>
    <div class="table">
      <div class="btns">
        <el-button type="primary" icon="fa fa-plus-circle" @click="add()"> 新建创意</el-button>
        <div class="make">
          <el-button size="small" @click="changeStatus(1)">开启</el-button>
          <el-button size="small" @click="changeStatus(0)">暂停</el-button>
          <el-button size="small" @click="del()">删除</el-button>
        </div>
      </div>
      <el-table ref="multipleTable" border :data="tableData" tooltip-effect="dark" style="width: 100%" @select="selectRow" @select-all="selectAll">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="title" label="推广计划"></el-table-column>
          <el-table-column prop="group_name" label="推广计划组"></el-table-column>
          <el-table-column prop="group_name" label="创意">
            <template slot-scope="scope">
              <div>{{ scope.row.adv_title }}</div>
              <div><img :src="getImage(scope.row.video_path)" style="width: 100px; height: 60px; margin-right: 5px;"></div>
            </template>
          </el-table-column>
          <el-table-column prop="url" label="落地页"></el-table-column>
          <el-table-column prop="handle_title" label="审核状态" width="100px"></el-table-column>
          <el-table-column prop="read_num" label="展示量" width="100px"></el-table-column>
          <el-table-column prop="look_num" label="点击量" width="100px"></el-table-column>
          <el-table-column prop="consume" label="支付" width="100px"></el-table-column>
          <el-table-column label="投放状态" show-overflow-tooltip width="100px">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.status" @change="changeStatusOne(scope.$index)"></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作" show-overflow-tooltip width="150">
            <template slot-scope="scope">
              <el-button size="mini" @click="edit(scope.$index)">编辑</el-button>
              <el-button type="danger" size="mini" @click="delOne(scope.row.adv_id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
    </div>
    <div class="page-c">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal">
      </el-pagination>
    </div>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="560px" top="3vh">
      <el-form ref="form" :model="form" :rules="rules" label-width="140px">
        <el-form-item label="所属推广计划名称" prop="plan_id">
          <el-select v-model="form.plan_id" placeholder="请选择计划" style="width: 320px;">
            <el-option :label="item.title" :value="item.plan_id" v-for="(item, index) in planLists" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属推广组名称" prop="group_id">
          <el-select v-model="form.group_id" placeholder="请选择推广组名称" style="width: 320px;">
            <el-option :label="item.group_name" :value="item.group_id" v-for="(item, index) in groupLists" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上传类型">
          <el-select v-model="form.upload" placeholder="请选择活动区域" style="width: 320px;">
            <el-option label="图片" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上传素材">
          <el-upload action="" ref="upload" class="avatar-uploader" :show-file-list="false" :on-change="logoUpload">
            <img v-if="form.video_path" :src="getImage(form.video_path)" class="avatar">
					<i v-else class="el-icon-plus avatar-uploader-icon"></i>
				</el-upload>        </el-form-item>
        <el-form-item label="创意名称" prop="adv_name">
          <el-input v-model="form.adv_name" placeholder="创意名称" style="width: 320px;"></el-input>
        </el-form-item>
        <el-form-item label="创意标题" prop="adv_title">
          <el-input v-model="form.adv_title" placeholder="创意标题" style="width: 320px;"></el-input>
        </el-form-item>
        <el-form-item label="落地页地址" prop="url">
          <el-input v-model="form.url" placeholder="落地页地址" style="width: 320px;"></el-input>
        </el-form-item>
        <el-form-item label="按钮文本">
          <el-select v-model="font1" placeholder="请选择活动区域" style="width: 320px;">
            <el-option label="立即下载" value="1"></el-option>
            <el-option label="立即查看" value="2"></el-option>
            <el-option label="立即报名" value="3"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button size="small" @click="dialogFormVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="submitForm('form')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'index',
  data() {
    return {
      font1: '1',
      keyword: '',
      title: '添加创意',
      dialogFormVisible: false,
      editFiles: [],
      dialogImageUrl: '',
      dialogVisible: false,
      tableData: [],
      form: {
        adv_id: '',
        plan_id: '',
        group_id: '',
        adv_name: '',
        adv_title: '',
        url: '',
        upload: '1',
        suffix: '',
        video_path: ''
      },
      rules: {
        status: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ],
        plan_id: [
          { required: true, message: '请选择计划', trigger: 'change' }
        ],
        group_id: [
          { required: true, message: '请选择推广组', trigger: 'change' }
        ],
        adv_name: [
          { required: true, message: '请输入创意名称', trigger: 'blur' }
        ],
        adv_title: [
          { required: true, message: '请输入创意标题', trigger: 'blur' }
        ],
        url: [
          { required: true, message: '请输入访问url', trigger: 'blur' }
        ]
      },
      planLists: [],
      groupLists: [],
      type: 'add',
      page: 1,
      pageSize: 10,
      pageTotal: 1,
      loading: true,
      ids: [],
      isEdit: true,
      group_name: ''
    };
  },
  created() {
    this.$http.post('/trader/index/group_form').then(res => {
      if (res.code === 200) {
        this.planLists = res.data.plan_lists;
        this.getData();
      }
    });
  },
  methods: {
    getGroupLists(plan_id) {
      return new Promise((resolve, reject) => {
        try {
          this.$http.post('/trader/index/getGroupForPlanId', {
            plan_id
          }).then(res => {
            resolve(res);
          });
        } catch (e) {
          reject({ code: 500, msg: '未知错误' });
        }
      });
    },
    getData() {
      this.$http.post('/trader/index/getAdvLists', {
        keyword: this.keyword,
        page: this.page,
        pageSize: this.pageSize
      }).then(res => {
        if (res.code === 200) {
          this.tableData = res.data;
          this.pageTotal = Math.ceil(res.count / this.pageSize);
          this.$function.hiddenLoading();
        }
      });
    },
    search() {
      this.page = 1;
      this.getData();
    },
    add() {
      this.dialogFormVisible = true;
      this.type = 'add';
      this.title = '添加创意';
    },
    edit(index) {
      this.type = 'edit';
      this.title = '编辑创意';
      this.isEdit = false;
      this.getGroupLists(this.tableData[index].plan_id).then(res => {
        if (res.code === 200) {
          this.groupLists = res.data.group_lists;
          this.dialogFormVisible = true;
          this.form = {
            adv_id: this.tableData[index].adv_id,
            plan_id: this.tableData[index].plan_id,
            group_id: this.tableData[index].group_id,
            adv_name: this.tableData[index].adv_name,
            adv_title: this.tableData[index].adv_title,
            url: this.tableData[index].url,
            upload: '1',
            suffix: '',
            video_path: this.tableData[index].video_path
          };
        }
      });
    },
    selectRow(sel, row) {
      const selected = sel.length && sel.indexOf(row) !== -1;
      if (selected) {
        if (this.ids.indexOf(row.adv_id) === -1) {
          this.ids.push(row.adv_id);
        }
      } else {
        if (this.ids.indexOf(row.adv_id) !== -1) {
          this.ids.splice(this.ids.indexOf(row.adv_id), 1);
        }
      }
    },
    selectAll(sel) {
      if (sel.length > 0) {
        this.ids = [];
        for (var i = 0; i < sel.length; i++) {
          this.ids.push(sel[i].adv_id);
        }
      } else {
        this.ids = [];
      }
    },
    changeStatusOne(index) {
      this.ids.push(this.tableData[index].adv_id);
      this.changeStatus(this.tableData[index].status ? 1 : 0);
    },
    changeStatus(val) {
      if (this.ids.length) {
        this.$http.post('/trader/index/changeAdvStatus', {
          ids: this.ids.join(','),
          value: val
        }).then(res => {
          if (res.code === 200) {
            this.getData();
            this.ids = [];
            this.$message.success('操作成功，仅审核通过的创意可修改状态');
          } else {
            this.$message.error('操作失败');
          }
        });
      }
    },
    delOne(id) {
      this.ids.push(id);
      this.del();
    },
    del() {
      if (this.ids.length) {
        this.$http.post('/trader/index/delAdv', {
          ids: this.ids.join(',')
        }).then(res => {
          if (res.code === 200) {
            this.getData();
            this.ids = [];
            this.$message.success('操作成功');
          } else {
            this.$message.error('操作失败');
          }
        });
      }
    },
    showOther(type) {
      this.$emit('showOther', type);
    },
    handleSizeChange(value) {
      this.page = 1;
      this.pageSize = value;
      this.getData();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.getData();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const url = this.type === 'add' ? '/trader/index/createAdv' : '/trader/index/saveAdv';
          this.$http.post(url, this.form).then(res => {
            if (res.code === 200) {
              this.page = 1;
              this.getData();
              this.dialogFormVisible = false;
              this.$message.success('操作成功');
              this.form = {
                adv_id: '',
                plan_id: '',
                group_id: '',
                adv_name: '',
                adv_title: '',
                url: '',
                upload: '1',
                suffix: '',
                video_path: ''
              };
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    logoUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 2MB');
        return;
      }
      if (file.raw.type.includes('gif')) {
        this.$message.error('图片格式不能是GIF');
        return;
      }

      this.$function.blobToDataURL(file.raw, res => {
        const imgType = file.raw.type.split('/');
        this.form.suffix = imgType[1];
        this.form.video_path = res;
      });
    },
    getImage(logo) {
      return logo.includes('base64,') ? logo : this.$Config.apiUrl + logo;
    }
  },
  watch: {
    'form.plan_id'(newVal, oldVal) {
      this.getGroupLists(newVal).then(res => {
        if (res.code === 200) {
          this.groupLists = res.data.group_lists;
          if (this.isEdit) {
            this.form.group_id = '';
          }
        }
      });
    }
  }
};
</script>

<style lang="less" scoped="">
  .action-lists {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 50px;
    background: #F7F8F8;
    .display {
      display: flex;
      align-items: center;
      height: 50px;
    }
    .left-btns {
      .display;
      div {
        width: 140px;
        text-align: center;
        height: 100%;
        line-height: 50px;
        color: #0056AF;
        cursor: pointer;
      }
      .selected {
        color: #166D9F;
        background: #fff;
      }
    }
    .right-action {
      .display;
      div {
        width: 34px;
        height: 34px;
        margin-left: 20px;
        cursor: pointer;
      }
    }
  }
  .table {
    width: calc(100% - 40px);
    padding: 20px;
    .make {
      padding: 20px 0;
    }
  }
  .page-c {
    background: #fff;
    padding: 20px;
  }
  img {
    width: 100%;
    height: 100%;
  }
  .avatar-uploader {
    width: 135px;
    display: inline-block;
    .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .el-upload:hover {
      border-color: #409EFF;
    }
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    min-width: 128px;
    height: 128px;
    line-height: 128px;
    text-align: center;
    border: 1px solid #ccc;
    border-radius: 5px;
  }
  .avatar {
    min-width: 128px;
    height: 128px;
    display: block;
  }
</style>
